<template>
    <div class="blueBg">
        <div class="inner">
            <h3>{{$t('news.title')}}</h3>

            <div class="textBox">
                <!-- お知らせ内容表示 -->
                <div v-if="!isNothingNewsData">
                    <newsitem v-for="post in limitCount " v-bind:key="post.no" v-bind="post" />
                </div>
                <div v-else>{{$t('top.notices.newsdatanotfound')}}</div>

                <!-- ページ送り -->
                <div v-if="!isNothingNewsData" class="arrow_fld" v-show="page_show">
                    <button type="button arrow_fld_border" class="btn btn-primary" @click="page_back">
                        <span aria-hidden="true">&laquo;</span>
                    </button>
                    <button type="button arrow_fld_border" class="btn btn-primary" @click="page_next">
                        <span aria-hidden="true">&raquo;</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import newsitem from './NewsItem.vue';
    import NewsDataService from '../../services/NewsDataService';
    import JSCookie from 'js-cookie';
    import config from './../../../config';

    export default {
        name: 'News',

        components: {
            newsitem,
        },
        
        beforeDestroy () {
            if (this.timeHandler !== null) {
                window.clearTimeout(this.timeHandler)
            }
        },
        
        methods: {
            async fetchData() {
                this.locale = JSCookie.get('app_locale') ? JSCookie.get('app_locale') : config.defaultLanguage;   
                this.getData = await NewsDataService.getNewsData(this.locale);  
                this.postdata = this.getData.data;
                if (this.postdata.length < 1) {
                    this.isNothingNewsData = true;
                }
                if (this.postdata.length < 11) {
                   this.page_show = false;
                } else {
                   this.page_show = true;
                }

            },
            news_click() {
                //メッセージ表示切替
                this.act_on = !this.act_on;
                this.act_off = !this.act_off;
            },
            page_back: function () {
                let now_count = 0;
                let page_calc = 0;

                //値10ずつ減少
                page_calc = parseInt(this.post_se["start"]) - 10;
                this.$set(this.post_se, 'start', page_calc);

                page_calc = parseInt(this.post_se["end"]) - 10;
                this.$set(this.post_se, 'end', page_calc);

                //マイナスの場合初期値
                if (this.post_se["start"] < 0) {
                    this.$set(this.post_se, 'start', '0');
                }

                if (this.post_se["end"] < 0) {
                    this.$set(this.post_se, 'end', '10');
                }

                //件数が最後ではないかつ表示10件以下の場合、10件表示に戻す
                if (this.post_se["end"] != this.postdata.length) {
                    now_count = this.post_se["end"] - this.post_se["start"];

                    if (now_count < 10) {
                        page_calc = this.post_se["end"] - 10;
                        this.$set(this.post_se, 'start', page_calc);
                        if (this.post_se["start"] < 0) { //マイナスの場合は0～10
                            this.$set(this.post_se, 'start', '0');
                            this.$set(this.post_se, 'end', '10');
                        }
                    }
                }

            },

            page_next: function () {
                let now_start = parseInt(this.post_se["start"]);
                let page_calc = 0;

                //start,endに10ずつ値を追加
                page_calc = parseInt(this.post_se["start"]) + 10;
                this.$set(this.post_se, 'start', page_calc);

                page_calc = parseInt(this.post_se["end"]) + 10;
                this.$set(this.post_se, 'end', page_calc);

                //値更新
                if (this.postdata.length <= this.post_se["start"]) { //最大値超過の場合戻す
                    this.$set(this.post_se, 'start', now_start);
                }

                if (this.postdata.length < this.post_se["end"] || this.post_se["end"] < this.post_se["start"]) { //最大値超過の場合最大値に
                    this.$set(this.post_se, 'end', this.postdata.length);
                }

                if (this.post_se["start"] == this.post_se["end"]) {
                    if (this.post_se["start"] == this.postdata.length) { //件数の最後
                        page_calc = this.post_se["end"] - 1;
                        this.$set(this.post_se, 'start', page_calc);
                    } else {
                        page_calc = this.post_se["end"] - 10;
                        this.$set(this.post_se, 'start', page_calc);
                    }
                }
            },

        },

        computed: {
            limitCount() { //v-for繰り返し表示用 json切り出し
                return this.postdata.slice(this.post_se["start"], this.post_se["end"])
            },
        },

        watch: {
            '$i18n.locale': function () {
                this.fetchData();    

                //表示を初期値に戻す
                this.$set(this.post_se, 'start', '0');
                this.$set(this.post_se, 'end', '10');

                this.page_show = false;
                if (this.postdata.length < 11) {
                   this.page_show = false;
                } else {
                   this.page_show = true;
                }

            }
        },

        created: function () {
            this.fetchData();
            if (this.postdata.length < 11) {
                this.page_show = false;
            }

        },

        data: () => {
            return {
                post_se: {
                    start: "0",
                    end: "10",
                },
                page_show: true,
                postdata: [],
                timeHandler: null,
                locale: "",
                getData: [],
                isNothingNewsData: false
         
            }
        }

    }
</script>

<style scoped>

</style>
